import { ControlPosition, DraggableBounds } from 'react-draggable';

export const DEFAULT_DRAGGABLE_POSITION: ControlPosition = { x: 0, y: 0 };
export const DEFAULT_DRAGGABLE_BOUNDS: DraggableBounds = { top: 0, left: 0, right: 0, bottom: 0 };
